import { render } from "./WysiwygEditor.vue?vue&type=template&id=4bd27d39&scoped=true"
import script from "./WysiwygEditor.vue?vue&type=script&lang=ts"
export * from "./WysiwygEditor.vue?vue&type=script&lang=ts"

import "./WysiwygEditor.vue?vue&type=style&index=0&id=4bd27d39&scoped=true&lang=scss"
import "./WysiwygEditor.vue?vue&type=style&index=1&id=4bd27d39&lang=scss"
script.render = render
script.__scopeId = "data-v-4bd27d39"

export default script